import { initSemparseClientInstrumentation } from "@workspace/tool-config/next/semparse-client-instrumentation.ts";

initSemparseClientInstrumentation({ appTag: "aristotle.xyz" });
